// ** Redux Imports
import rootReducer from './rootReducer';
import { configureStore } from '@reduxjs/toolkit';
import { sanctionsApi } from '@features/sanctions/service';
import { liquidityApi } from '@features/liquidity/service';
import { saldoApi } from '@features/liquidity/service/saldo-api';
import { unstoppableLiquidityApi } from '@features/unstoppable-liquidity/service';
import { usersApi } from '../../features/users/service';
import { transactionsApi } from '@features/transactions/service';
import { conversionsApi } from '@features/conversions/service';
import { QRApplicationsApi } from '@features/qr-applications/service';
import { rolesApi } from '@features/roles/service';
import { commissionsApi } from '@features/commissions/service';
import { limitsApi } from '@features/limits/service';
import { balanceApi } from '@features/balance/service';
import { notificationsApi } from '@features/notifications/service/notifications-api';
import { pushNotificationsApi } from '@features/push-notifications/service/push-notifications-api';
import { faqApi } from '@features/faq/service/faq-api';
import { newsApi } from '@features/news/service/news-api';
import { balanceReportApi } from '@features/balance-report/service';
import { adminLogsApi } from '@features/admin-logs/service';
import { discountRatesApi } from '@features/discount-rates/service/discount-rates-api';
import { referralCodeApi } from '@features/referral-code/service';
import { userSearchApi } from '@features/user-search/service';
import { complianceApi, monthlyDepositsApi } from '@features/compliance/service';
import { depositAddressApi } from '@features/deposit-address/service';
import { transactionsCheckApi } from '@features/transactions-check/service';
import { systemLogsApi } from '@features/system-logs/service/system-logs-api';
import { fiatAssetsApi } from '@features/fiat-assets/service';
import { emailCampaignApi } from '@features/email-campaign/service';
import { marketingApi } from '@features/marketing/service';
import { quickSearchApi } from '@features/quick-search/service';
import { smsproApi } from '@features/smspro/service';
import { binanceBrokerApi } from '@features/binance-broker/service';
import { transferApi } from '@features/transfer/service';
import { usdtVolumeApi } from '@features/usdt-volume/service';
import { fiatVolumeApi } from '@features/fiat-volume/service';
import { onboardingApi } from '@features/onboarding/service';
import { questionareApi } from '@features/questionare/service/questionare-api';
import { deeplinksApi } from '@features/deeplinks/service';
import { misuseApi } from '@features/misuse/service';
import { blockLogApi } from '@features/block-log/service';
import { cryptoAddressesApi } from '@features/crypto-addresses/service';

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      sanctionsApi.middleware,
    ]).concat([
      liquidityApi.middleware,
    ]).concat([
      saldoApi.middleware,
    ]).concat([
      unstoppableLiquidityApi.middleware,
    ]).concat([
      usersApi.middleware,
    ]).concat([
      transactionsApi.middleware,
    ]).concat([
      rolesApi.middleware,
    ]).concat([
      commissionsApi.middleware,
    ]).concat([
      conversionsApi.middleware,
    ]).concat([
      limitsApi.middleware,
    ]).concat([
      QRApplicationsApi.middleware,
    ]).concat([
      balanceApi.middleware,
    ]).concat([
      notificationsApi.middleware,
    ]).concat([
      pushNotificationsApi.middleware,
    ]).concat([
      faqApi.middleware,
    ]).concat([
      newsApi.middleware,
    ]).concat([
      balanceReportApi.middleware,
    ]).concat([
      adminLogsApi.middleware,
    ]).concat([
      discountRatesApi.middleware,
    ]).concat([
      referralCodeApi.middleware,
    ]).concat([
      userSearchApi.middleware,
    ]).concat([
      complianceApi.middleware,
    ]).concat([
      monthlyDepositsApi.middleware,
    ]).concat([
      depositAddressApi.middleware,
    ]).concat([
      transactionsCheckApi.middleware,
    ]).concat([
      systemLogsApi.middleware,
    ]).concat([
      fiatAssetsApi.middleware,
    ]).concat([
      emailCampaignApi.middleware,
    ]).concat([
      marketingApi.middleware,
    ]).concat([
      quickSearchApi.middleware,
    ]).concat([
      smsproApi.middleware,
      binanceBrokerApi.middleware,
    ]).concat([
      transferApi.middleware,
    ]).concat([
      usdtVolumeApi.middleware,
    ]).concat([
      fiatVolumeApi.middleware,
    ]).concat([
      onboardingApi.middleware,
    ]).concat([
      questionareApi.middleware,
    ]).concat([
      deeplinksApi.middleware,
    ]).concat([
      misuseApi.middleware,
    ]).concat([
      blockLogApi.middleware,
    ]).concat([
      cryptoAddressesApi.middleware,
    ])
  },
});

export { store };
